import { Validator } from '@vista-digital/validator';
/**
 * Colour theme options for the Google reCAPTCHA V2 component.
 */
export var GoogleRecaptchaV2Theme;
(function (GoogleRecaptchaV2Theme) {
    /**
     * Render the Google reCAPTCHA V2 component in a light colour theme (default).
     */
    GoogleRecaptchaV2Theme["Light"] = "light";
    /**
     * Render the Google reCAPTCHA V2 component in a dark colour theme.
     */
    GoogleRecaptchaV2Theme["Dark"] = "dark";
})(GoogleRecaptchaV2Theme || (GoogleRecaptchaV2Theme = {}));
export const googleRecaptchaV2ThemeValidator = Validator.oneOf(Object.values(GoogleRecaptchaV2Theme));
//# sourceMappingURL=theme.js.map